module.exports = __webpack_public_path__ + "img/cleaf6.d2b2bbd7.jpg";